<template>
<div>
    <div class="kit__utils__heading">
      <h5>
        <span class="mr-3">Banco de descriptores y yo puedo</span>
      </h5>
    </div>
    <div class="card-body">
      <b-container>
        <b-card no-body>
          <b-tabs card v-model="tabIndex">
            <b-tab title="Descriptores" >
              <descriptor v-if="tabIndex === 0" :doesEdit="true" />
            </b-tab>
            <b-tab title="Yo puedo">
              <i-can v-if="tabIndex === 1" :doesEdit="true"/>
            </b-tab>
          </b-tabs>
        </b-card>
      </b-container>
    </div>
  </div>
</template>

<script>
import iCan from '@/components/custom/ican'
import descriptor from '@/components/custom/descriptor'
import { mapState } from 'vuex'

export default {
  components: {
    iCan,
    descriptor,
  },
  name: 'ClassRoomSBG',
  data() {
    return {
      tabIndex: 0,
    }
  },
  computed: {
    ...mapState(['user']),
  },
}
</script>
